import { render } from "./StateWithPopover.vue?vue&type=template&id=ec7e04fc&scoped=true"
import script from "./StateWithPopover.vue?vue&type=script&lang=js"
export * from "./StateWithPopover.vue?vue&type=script&lang=js"

import "./StateWithPopover.vue?vue&type=style&index=0&id=ec7e04fc&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ec7e04fc"]])

export default __exports__